import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { SiteStepperModel } from 'src/app/models/index';
@Injectable({
  providedIn: 'root'
})
export class SiteStepperService {
  stepperSubject: Subject<SiteStepperModel>;
  private stepOneSource: Subject<UntypedFormGroup> = new Subject();
  stepOne: Observable<UntypedFormGroup> = this.stepOneSource.asObservable();
  private stepTwoSource: Subject<UntypedFormGroup> = new Subject();
  stepTwo: Observable<UntypedFormGroup> = this.stepTwoSource.asObservable();
  calledSendStepper = false;
  constructor() {
    this.stepperSubject = new Subject<SiteStepperModel>();
    // this.stepOne.subscribe(form =>
    //   form.valueChanges.subscribe(val => {
    //     this.mainForm.value.firstName = val.firstName
    //     this.mainForm.value.lastName = val.lastName
    //     this.mainForm.value.extraName = val.extraName
    //   })
    // )
    // this.stepTwo.subscribe(form =>
    //   form.valueChanges.subscribe(val => {
    //     // console.log(val)
    //     this.mainForm.value.address = val.address
    //   })
    // )
  }
  public getSendStepper() {
    return this.calledSendStepper;
  }
  public setSendStepper(value) {
    this.calledSendStepper = value;
  }
  public sendStepperSubject = (value: SiteStepperModel) => {
    this.stepperSubject.next(value);
  };
  public getStepperSubject = (): Observable<SiteStepperModel> => {
    return this.stepperSubject.asObservable();
  };
  public unSubscribeStepperSubject = () => {
    this.stepperSubject.observers = [];
  };
  public stepReady = (form: UntypedFormGroup, part: any) => {
    switch (part) {
      case 'one': {
        this.stepOneSource.next(form);
      }
      // eslint-disable-next-line no-fallthrough
      case 'two': {
        this.stepTwoSource.next(form);
      }
    }
  };
}
